import React, { memo } from 'react'
import { varAlpha } from 'minimal-shared/utils'
import { styled } from '@mui/material/styles'

import FaIcon from '../faIcon/FaIcon'
import Text from '../text/Text'

const RecordsNotFound = ({
  action,
  filled = true,
  title,
  icon,
  description
}) => (
  <ContentRoot filled={filled} sx={{ py: 10 }}>
    {icon && <FaIcon icon={icon} size='3x' />}
    {title && (
      <Text
        variant='h6'
        label={title}
        sx={[
          {
            mt: 1,
            textAlign: 'center',
            color: 'text.disabled'
          }
        ]}
      />
    )}

    {description && (
      <Text
        variant='soft'
        sx={[
          {
            mt: 1,
            textAlign: 'center',
            color: 'text.disabled'
          }
        ]}
        label={description}
      />
    )}
    {action && action}
  </ContentRoot>
)

export default memo(RecordsNotFound)

const ContentRoot = styled('div', {
  shouldForwardProp: (prop) => !['filled', 'sx'].includes(prop)
})(({ filled, theme }) => ({
  flexGrow: 1,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(0, 3),
  ...(filled && {
    borderRadius: theme.shape.borderRadius * 2,
    backgroundColor: varAlpha(theme.vars.palette.grey['500Channel'], 0.04),
    border: `dashed 1px ${varAlpha(theme.vars.palette.grey['500Channel'], 0.08)}`
  })
}))
